import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { fadeInAnimation } from '@core/route-animation';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
  animations: [fadeInAnimation]
})
export class LanguageComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

  getAnimationData(o: RouterOutlet) {
    const routeData = o.activatedRouteData.animation;
    return routeData ? routeData : 'rootPage';
  }

}
